/**
 * Values are POA Bridge specific
 * todo: use SupportedChainName as keys
 */
export enum BlockchainEnum {
  NEAR = "near:mainnet",
  ETHEREUM = "eth:1",
  BASE = "eth:8453",
  ARBITRUM = "eth:42161",
  BITCOIN = "btc:mainnet",
  SOLANA = "sol:mainnet",
  DOGECOIN = "doge:mainnet",
  TURBOCHAIN = "eth:1313161567",
  AURORA = "eth:1313161554",
  XRPLEDGER = "xrp:mainnet",
}
